import { routes } from 'app/routing/routesConfig';
import { useAppSelector } from 'app/store';
import { getRelease, getReleaseVersion } from 'app/store/Releases/selectors';
import { useLocation } from 'react-router-dom';
import { LabelV2Version } from 'types/releases';

export const useReleaseCallbackUrl = (
  tab: 'details' | 'contributions' | 'lyrics' | 'splits',
  releaseVersion?: LabelV2Version
) => {
  const { pathname } = useLocation();
  const release = useAppSelector(getRelease);
  const version = useAppSelector(getReleaseVersion);
  const songGuid = releaseVersion?.song.guid ?? version?.song.songGuid;
  const versionGuid = releaseVersion?.guid ?? version?.metadata.guid;

  return routes.song.path.replace(
    ':guid',
    `${songGuid}/${tab}?callback=${pathname}&versionGuid=${versionGuid}&releaseType=${release?.type}`
  );
};
